import React, { useEffect, useState } from 'react';
import { getUtilityLinks } from '../lib/sanity';
import { safeToolUrl } from '../lib/toolUrls';

function FinancialTools() {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    getUtilityLinks()
      .then((data) => {
        if (!cancelled) setTools((data || []).filter((tool) => tool.name && safeToolUrl(tool.url)));
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [attempt]);

  return (
    <main className="relative isolate min-h-screen overflow-hidden bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse delay-1000"></div>
      </div>
      <section className="relative z-10 pt-28 pb-8 md:pt-36 md:pb-12">
        <div className="container-custom relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Financial Planning <span className="text-[#F4900C]">Tools</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto">Useful tools to help you explore your finances and plan ahead.</p>
          </div>
        </div>
      </section>
      <section className="container-custom relative z-10 pb-16 md:pb-24">
        <div className="max-w-3xl mx-auto">
          {loading ? (
            <p role="status" className="text-gray-600">Loading tools...</p>
          ) : error ? (
            <div role="alert">
              <p className="text-gray-600 mb-4">We couldn't load the tools. Please try again.</p>
              <button type="button" onClick={() => setAttempt((value) => value + 1)} className="btn-secondary px-5 py-2">Try again</button>
            </div>
          ) : tools.length === 0 ? (
            <p className="text-gray-600">Financial planning tools will be added soon.</p>
          ) : (
            <ol className="list-decimal pl-7 space-y-6 marker:text-gray-500">
              {tools.map((tool) => {
                const backupUrl = safeToolUrl(tool.backupUrl, true);
                return (
                  <li key={tool._id} className="pl-2">
                    <a href={safeToolUrl(tool.url)} target="_blank" rel="noopener noreferrer" className="text-lg font-semibold text-gray-900 underline decoration-[#F4900C] underline-offset-4 hover:text-[#F4900C]">
                      {tool.name}<span className="sr-only"> (opens in a new tab)</span>
                    </a>
                    {tool.shortDescription && <p className="text-gray-600 mt-2 whitespace-pre-line">{tool.shortDescription}</p>}
                    {backupUrl && (
                      <p className="mt-2 text-sm">
                        <a href={backupUrl} target="_blank" rel="noopener noreferrer" className="text-gray-600 no-underline">Open backup version<span className="sr-only"> (opens in a new tab)</span></a>
                      </p>
                    )}
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </section>
    </main>
  );
}

export default FinancialTools;
